import React, { useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Products from '../components/Products';
import FarmTechnology from '../components/FarmTechnology';
import Gallery from '../components/Gallery';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import QuoteModal from '../components/QuoteModal';

const Home = () => {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Header onRequestQuote={() => setIsQuoteModalOpen(true)} />
      <Hero onRequestQuote={() => setIsQuoteModalOpen(true)} />
      <About />
      <Products onRequestQuote={() => setIsQuoteModalOpen(true)} />
      <FarmTechnology />
      <Gallery />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
      <QuoteModal 
        isOpen={isQuoteModalOpen} 
        onClose={() => setIsQuoteModalOpen(false)} 
      />
    </div>
  );
};

export default Home;
